import { render, staticRenderFns } from "./museum-of-ethnography.vue?vue&type=template&id=6f0f455b&scoped=true&"
import script from "./museum-of-ethnography.vue?vue&type=script&lang=js&"
export * from "./museum-of-ethnography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f455b",
  null
  
)

export default component.exports